import React from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { SummaryDealerDetailsAC } from './AC/SummaryDealerDetails.AC';
import { SummaryDealerDetailsOV } from './OV/SummaryDealerDetails.OV';
import { SummaryDealerDetailsAP } from './AP/SummaryDealerDetails.AP';
import { SummaryDealerDetailsDS } from './DS/SummaryDealerDetails.DS';
import { SummaryDealerDetailsOV as SummaryDealerDetailsOV_GB } from './OV/GB/SummaryDealerDetails.OV';
import { SummaryDealerDetailsStyled } from './SummaryDealerDetailsStyled';
import { SC } from 'src/styles/theme';
import { Pages } from '../../types/pages';

export type SummaryPriceDetailsProps = SC & {
    generatedIndex?: number;
    page?: Pages;
};
const SummaryPriceDetails = (props: SummaryPriceDetailsProps) => {
    if (BRAND === 'AC') return <SummaryDealerDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <SummaryDealerDetailsOV_GB {...props} /> : <SummaryDealerDetailsOV {...props} />;
    if (BRAND === 'AP') return <SummaryDealerDetailsAP {...props} />;
    if (BRAND === 'DS') return <SummaryDealerDetailsDS {...props} />;
    return <SummaryDealerDetailsStyled {...props} />;
};

export default SummaryPriceDetails;
